// Load all reducers
import { combineReducers } from 'redux';

import userReducer from '../user';
import enclaveReducer from '../enclave/reducer';
import modalReducer from '../modal/reducer';
import workflowReducer from '../workflow/reducer';
import safelistsReducer from '../safelists';
import sourceReducer from '../source/reducer';

// Every store will be placed here, the reason there is an option to export the object as well as 
// the combined reducers is in case you need to another reducer (like an ajax instance) on a higher level

export const allFeatureReducers = {
  enclaves: enclaveReducer,
  modals: modalReducer,
  user: userReducer,
  workflows: workflowReducer,
  safelists: safelistsReducer,
  source: sourceReducer,
};

export default combineReducers(allFeatureReducers);
